import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

const handle = (error, fallback) => {
    if (error.response?.data) throw error.response.data;
    throw error.message || fallback;
};

// 1. Queue of New Stock Received transfers pending this user's verification (role/CC scoped server-side)
export const getVerifyNewStockReceivedQueue = async (roleId, userid) => {
    try {
        const response = await axios.get(`${base}/Purchase/GetVerfiyNewStockReceivedGrid`, { params: { RoleId: roleId, Userid: userid } });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch New Stock Received verification queue'); }
};

// 2. Item-level grid for one transfer (Refno)
export const getViewNewStockReceivedGrid = async (trno) => {
    try {
        const response = await axios.get(`${base}/Purchase/ViewNewStockReceivedGrid`, { params: { Trno: trno } });
        return response.data;
    } catch (error) { return handle(error, 'Failed to fetch item details'); }
};

// 3. Verify/Approve/Reject — ActionRemarks/RoleID/Createdby are bound exactly as this backend's
// PurchaseDataLayer.ApproveNewStockIssueRecieved reads them (not the plain "Remarks" key legacy's
// own MVC controller relabels internally before calling the same business method).
export const approveNewStockIssueRecieved = async (payload) => {
    try {
        const response = await axios.put(`${base}/Purchase/ApproveNewStockIssueRecieved`, payload);
        return response.data;
    } catch (error) { return handle(error, 'Failed to submit verification'); }
};
